import styled from 'styled-components';

export const Container = styled.div`
  .card-container {
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  }
`;
